import configureSearch from './skin/search';
import '../scss/index.scss';

document.addEventListener('DOMContentLoaded', () => {
  // Configure Search for Typeahead feature
  configureSearch();
}, false);

$(document).ready(function () {
  var $header = $('.allHands-navbar');
  //if no banner, navbar needs to move to the top
  const divWithClassExists = document.querySelectorAll(
    'div.header_banner_container'
  ).length >
    0;

  if (!divWithClassExists) {
    $header.addClass('no-officialbanner');
  } else {
    $header.addClass('officialBanner');
  }

  /**
  * Sets the class of the header based on the window scroll position
  */
  function calculateHeader() {

    var y = window.pageYOffset;
    if (y > 2) {
      $header.addClass('away-from-top');
    } else if (y < 2) {
      $header.removeClass('away-from-top');
    }
  }

  window.addEventListener("scroll", calculateHeader);
  calculateHeader();

  /**
   * Setup variables for automatic menu width detection
   */
  var toid;
  var once = false;
  var $navContainer = $('nav.navbar');
  var $mainNav = $("#main-nav");
  var $collapse = $navContainer.find('.navbar-collapse');
  var $menuItems = $mainNav.children();

  /**
   * Window resize
   */
  $(window).resize(() => {
    // Clear the debounce timer
    clearTimeout(toid);

    // If the window is below 992px we don't want to do anything except remove the force-mobile class
    // because the normal css styles take over from here.
    if (!window.matchMedia('screen and (min-width: 992px)').matches) {
      $header.removeClass('force-mobile');
      return;
    }

    // Debounce timer
    toid = setTimeout(() => {
      checkMainMenuWidth();
      once = false;
    }, 10);

    // This allows the function to fire immediately and only after the debounce timeout is complete
    // so that there isn't as much flashing of content.
    if (!once) {
      checkMainMenuWidth();
      once = true;
    }
  });

  function checkMainMenuWidth() {
    // Remove classes first
    $header.removeClass('force-mobile');
    $mainNav.removeClass('sm-collapsible');
    $collapse.removeClass('show');
    $mainNav.find('.dropdown-menu').css('position', '');

    // Get the menu height with all menu items
    var mainHeight = $mainNav.height();
    $menuItems.hide();
    // Get the menu height with a single item displaying
    $($menuItems[0]).show();
    var singleHeight = $mainNav.height();
    // See if the height of the menu is different with one item as opposed to all items
    if (singleHeight < mainHeight) {
      // If it is taller, then add these classes
      $mainNav.addClass('sm-collapsible');
      $header.addClass('force-mobile');
      // Setting position static is what tells smartmenus to use click vs hover events for dropdowns
      $mainNav.find('.dropdown-menu').css('position', 'static');
    }
    // Display all the menu items again
    $menuItems.show();
  }

  // Only run first time if we are below 992px (otherwise classes are removed that we need)
  if (window.matchMedia('screen and (min-width: 992px)').matches) {
    setTimeout(() => {
      checkMainMenuWidth();
    },
      250);
  }

}); //ready
